import {
  Component, EventEmitter, Input, OnInit, Output, Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StaffFilter } from './staffFilter';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-staff-filters',
  templateUrl: './staff-filters.component.html',
  styleUrls: [ './staff-filters.component.scss' ],
})
export class StaffFiltersComponent implements OnInit {
  mainFilter: StaffFilter;
  originalFilter: StaffFilter;
  noChange = false;
  permissions: any;
  roleFilters: { text: string, parameter: keyof StaffFilter }[] = [
    { text: 'Show basic members', parameter: 'showBasicMembers' },
    { text: 'Show default administrators', parameter: 'showDefaultAdministrators' },
    { text: 'Show default supervisors', parameter: 'showDefaultSupervisors' },
    { text: 'Show custom roles', parameter: 'showCustomRoles' },
  ];

  constructor(
    public dialogRef: MatDialogRef<StaffFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StaffFilter,
    private authService: AuthService,
  ) {
    this.mainFilter = new StaffFilter(data);
    this.originalFilter = new StaffFilter(data);
    this.authService.permissions$.subscribe((permissions) => {
      this.permissions = permissions;
    });
  }

  ngOnInit(): void {
    if (!this.mainFilter) {
      this.mainFilter = new StaffFilter();
      this.originalFilter = new StaffFilter();
    }
  }

  updateCheckboxFilter(parameter: keyof StaffFilter, event: any): void {
    const isChecked = event.target.checked;

    if (parameter === 'showInactiveMembers') {
      // Special handling for show inactive members
      this.mainFilter.showInactiveMembers = isChecked;

      if (isChecked) {
        // When show inactive is checked, uncheck and disable all other role filters
        this.mainFilter.showBasicMembers = false;
        this.mainFilter.showDefaultAdministrators = false;
        this.mainFilter.showDefaultSupervisors = false;
        this.mainFilter.showCustomRoles = false;
        this.mainFilter.showOnlyAssignedToMe = false;
      }
    } else {
      // For all other checkboxes, if show inactive is checked, prevent changes
      if (this.mainFilter.showInactiveMembers) {
        // Revert the checkbox state since show inactive is checked
        event.target.checked = !isChecked;
        return;
      }

      // Normal checkbox behavior
      (this.mainFilter[parameter] as boolean) = isChecked;
    }
  }

  // Helper method to check if other checkboxes should be disabled
  isCheckboxDisabled(parameter: keyof StaffFilter): boolean {
    return this.mainFilter.showInactiveMembers && parameter !== 'showInactiveMembers';
  }

  // Helper method to get the tooltip for show inactive members
  getShowInactiveTooltip(): string {
    return 'When checked, other filters are disabled because inactive users don\'t have roles. Uncheck to re-enable other filters.';
  }

  hasChanges(): boolean {
    return true; // Always allow saving to avoid confusing users
  }

  saveFilters(): void {
    console.log('saveFilters', this.mainFilter);
    this.dialogRef.close({
      filter: this.mainFilter,
      noChange: false,
    });
  }

  closeModal(): void {
    this.dialogRef.close({ noChange: true });
  }

  getHelpText(parameter: keyof StaffFilter): string {
    const helpTexts: { [key: string]: string } = {
      'showOnlyAssignedToMe': 'Show only staff members who are directly assigned to your supervision or management',
      'showBasicMembers': 'Show users with basic member permissions and standard access levels',
      'showDefaultAdministrators': 'Show users with administrator privileges and full system access',
      'showDefaultSupervisors': 'Show users with supervisor privileges and team management capabilities',
      'showCustomRoles': 'Show users with custom role assignments and specialized permissions',
      'showInactiveMembers': 'Include staff members who are currently inactive, deactivated, or have left the organization',
    };

    return helpTexts[parameter] || 'Additional filter option for staff display';
  }
}
